import { X6 as X6_2025, X6Assy as X6_Assy_2025 } from "./XSeriesProducts/X6/X6Chassis-2025";
import { X4 as X4_2025, X4Assy as X4_Assy_2025 } from "./XSeriesProducts/X4/X4Chassis-2025";
import { X2 as X2_2025, X2Assy as X2_Assy_2025 } from "./XSeriesProducts/X2/X2Chassis-2025";
import { X6 as X6_2024, X6Assy as X6_Assy_2024 } from "./XSeriesProducts/X6/X6Chassis-2024";
import { X4 as X4_2024, X4Assy as X4_Assy_2024 } from "./XSeriesProducts/X4/X4Chassis-2024";
import { X2 as X2_2024, X2Assy as X2_Assy_2024 } from "./XSeriesProducts/X2/X2Chassis-2024";
import { X4 as X4_2023, X4Assy as X4_Assy_2023 } from "./XSeriesProducts/X4/X4Chassis-2023";
import { E4 as E4_2025, E4Assy as E4_Assy_2025 } from "./ESeriesProducts/E4/E4Chassis-2025";
import { E4 as E4_2024, E4Assy as E4_Assy_2024 } from "./ESeriesProducts/E4/E4Chassis-2024";
import { ChassisType } from "../../../@types/ChassisType";
import { E2 as E2_2024 } from "./ESeriesProducts/E2/E2Chassis-2024";
import { E2 as E2_2025 } from "./ESeriesProducts/E2/E2Chassis-2025";
import { E2Shuttle as E2Shuttle_2025 } from "./ESeriesProducts/E2-Shuttle/E2-ShuttleChassis-2025";
import { E6Shuttle as E6Shuttle_2025 } from "./ESeriesProducts/E6-Shuttle/E6-ShuttleChassis-2025";


const X6Chassis: ChassisType[] = [
    X6_2024, 
    X6_2025, 
];

const X6ChassisAssy: ChassisType[] = [
    X6_Assy_2024,
    X6_Assy_2025
]; 

const X4Chassis: ChassisType[] = [
    X4_2023, 
    X4_Assy_2023,
    X4_2024,
    X4_Assy_2024,
    X4_2025,
    X4_Assy_2025
];

const X4ChassisAssy: ChassisType[] = [
    X4_Assy_2023,
    X4_Assy_2024,
    X4_Assy_2025
];

const X2Chassis: ChassisType[] = [
    X2_2024,
    X2_2025,
];

const X2ChassisAssy: ChassisType[] = [
    X2_Assy_2024,
    X2_Assy_2025
];

const E4Chassis: ChassisType[] = [
    E4_2024,
    E4_Assy_2024,
    E4_2025,
    E4_Assy_2025
]

const E2Chassis: ChassisType[] = [
    E2_2024,
    E2_2025
]

const E2ShuttleChassis: ChassisType[] = [
    E2Shuttle_2025
]

const E6ShuttleChassis: ChassisType[] = [
    E6Shuttle_2025
];

const E4ChassisAssy: ChassisType[] = [
    E4_2024,
    E4_Assy_2024,
    E4_2025,
    E4_Assy_2025
]

const allChassisAssy: ChassisType[] = [
    ...X6ChassisAssy,
    ...X4ChassisAssy,
    ...X2ChassisAssy,
    ...E4ChassisAssy
]

const allChassis: ChassisType[] = [
    ...X6Chassis,
    ...X4Chassis,
    ...X2Chassis,
    ...E4Chassis
]

const allWarrantyChassis: ChassisType[] = [
    ...X6Chassis,
    ...X4Chassis,
    ...X2Chassis,
    ...E4Chassis
]

const allWarrantyChassisInternational: ChassisType[] = [
    ...X6Chassis,
    ...X4Chassis,
    ...X2Chassis,
    ...E4Chassis,
    ...E2Chassis,
    ...E2ShuttleChassis,
    ...E6ShuttleChassis
]


export { 
    X6Chassis, 
    X6ChassisAssy, 
    X4Chassis, 
    X4ChassisAssy, 
    X2Chassis, 
    X2ChassisAssy, 
    E4Chassis, 
    E4ChassisAssy, 
    allChassis,
    allChassisAssy,
    allWarrantyChassis,
    allWarrantyChassisInternational
};